import { chakra } from '@chakra-ui/react'
import { Switch } from '@verbit-ai/verbit-ui-library'

import { shouldForwardProp } from 'src/utils/should-forward-prop'

const SWITCH_HEIGHT = '15px'
const SWITCH_WIDTH = '30px'
const SWITCH_DOT_WIDTH = '15px'

export const VerbitSwitch = chakra(Switch, {
    baseStyle: () => ({
        height: SWITCH_HEIGHT,
        width: SWITCH_WIDTH,
    }),
})

type VerbitSwitchTrackProps = { $isChecked: boolean }
export const VerbitSwitchTrack = chakra<typeof Switch.Track, VerbitSwitchTrackProps>(Switch.Track, {
    baseStyle: ({ $isChecked, theme }) => ({
        height: SWITCH_HEIGHT,
        border: 'none',
        background: $isChecked ? theme.palette.verbitSwitch.trackActiveBgColor : theme.palette.verbitSwitch.trackInactiveBgColor,
    }),
    shouldForwardProp,
})

type VerbitSwitchDotProps = { $isChecked: boolean }
export const VerbitSwitchDot = chakra<typeof Switch.Dot, VerbitSwitchDotProps>(Switch.Dot, {
    baseStyle: ({ $isChecked, theme }) => ({
        height: SWITCH_HEIGHT,
        width: SWITCH_DOT_WIDTH,
        border: `2px solid ${$isChecked ? theme.palette.verbitSwitch.trackActiveBgColor : theme.palette.verbitSwitch.trackInactiveBgColor}`,
        transform: `translateX(${$isChecked ? SWITCH_DOT_WIDTH : 0})`,
        background: theme.palette.verbitSwitch.default,
    }),
    shouldForwardProp,
})
